/*
 * =============================================================================
 * Project: boilerplate
 * Created Date: 2018-03-13, 12:21:13
 * Author: Przemysław Drzewicki <przemyslaw.drzewicki@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-03-15, 16:31:10
 * Modified By: Przemysław Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada S.A
 * =============================================================================
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Tooltip } from 'antd';

import './style.sass';

const UpdateButton = props => 
  (
    <Tooltip placement="top"
      title="Edytuj wpis.">
      <Button type="primary"
        onClick={props.callback}
        shape="circle"
        icon="edit"
        size="default" 
        className="update-button"
      />
    </Tooltip>
  )

UpdateButton.propTypes = {
  callback: PropTypes.func.isRequired
}

export default UpdateButton;



// WEBPACK FOOTER //
// ./src/rcapp/components/layout/updateButton/index.js